package dev.wyns.ventrova.data.model

/**
 * Kind of venue, matching the `category` column of the places database. [ChipShop] is not a
 * database category: it is derived from fast food places (see `SqlitePlaceRepository`).
 */
enum class PlaceCategory(val databaseValue: String) {
    Restaurant("restaurant"),
    FastFood("fast_food"),
    ChipShop("chip_shop"),
    Cafe("cafe"),
    Bakery("bakery"),
    Dessert("dessert"),
    FoodTruck("food_truck"),
    Shop("shop");

    companion object {
        fun fromDatabase(value: String): PlaceCategory? = entries.firstOrNull { it.databaseValue == value }
    }
}
